import { createSlice } from '@reduxjs/toolkit';
import { Paginated } from '../../services/api-handlers/pagination';
import { DailyInspiration, Nullable } from '../../types';
import { takeOne } from '../../helpers/store';
import {
    createDailyInspiration,
    deleteDailyInspiration,
    getAllDailyInspirations,
    getDailyInspiration,
    listDailyInspirations,
    updateDailyInspiration,
} from '../thunks/daily-inspiration-thunks';
import { ReducerState } from '../configure-store';

export interface DailyInspirationState extends ReducerState {
    data: Paginated<DailyInspiration>;
    current: Nullable<DailyInspiration>;
}

const initialState: DailyInspirationState = {
    error: '',
    loading: 'none',
    requestIds: [],
    current: null,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
};

const slice = createSlice({
    name: 'daily-inspiration',
    initialState,
    reducers: {
        resetDailyInspirationCurrent: (state: DailyInspirationState) => {
            state.current = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(listDailyInspirations.pending, takeOne.pendingActionCase)
            .addCase(listDailyInspirations.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.data = action.payload;
            })
            .addCase(listDailyInspirations.rejected, takeOne.rejectedActionCase)

            .addCase(getAllDailyInspirations.pending, takeOne.pendingActionCase)
            .addCase(getAllDailyInspirations.fulfilled, takeOne.fulfilledActionCase)
            .addCase(getAllDailyInspirations.rejected, takeOne.rejectedActionCase)

            .addCase(getDailyInspiration.pending, takeOne.pendingActionCase)
            .addCase(getDailyInspiration.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.current = action.payload;
            })
            .addCase(getDailyInspiration.rejected, takeOne.rejectedActionCase)

            .addCase(createDailyInspiration.pending, takeOne.pendingActionCase)
            .addCase(createDailyInspiration.fulfilled, takeOne.fulfilledActionCase)
            .addCase(createDailyInspiration.rejected, takeOne.rejectedActionCase)

            .addCase(updateDailyInspiration.pending, takeOne.pendingActionCase)
            .addCase(updateDailyInspiration.fulfilled, takeOne.fulfilledActionCase)
            .addCase(updateDailyInspiration.rejected, takeOne.rejectedActionCase)

            .addCase(deleteDailyInspiration.pending, takeOne.pendingActionCase)
            .addCase(deleteDailyInspiration.fulfilled, takeOne.fulfilledActionCase)
            .addCase(deleteDailyInspiration.rejected, takeOne.rejectedActionCase);
    },
});

export const { resetDailyInspirationCurrent } = slice.actions;

export default slice.reducer;
